import {apiFactory} from './index'

const api = apiFactory('admin')

export function queryMenus() {
  return api.get('/system/mainframe/menu')
    .then(res => res.data)
}

export function querySubMenus(id) {
  if (!id) {
    return queryMenus()
  }

  return api.get(`/system/mainframe/submenu?optid=${id}`)
    .then(res => res.data)
}
